import { get, isNumber } from 'lodash';
import { LevelDetails } from '@/core/player-state';
import Hls, { CapLevelController, Level, LevelSwitchingData } from 'hls.js';

export function hlsLevelToLevelDetails(level: Level | LevelSwitchingData): LevelDetails {
    return {
        url: get(level, 'url.0'),
        bandwidth: level.attrs.BANDWIDTH,
        codecs: level.attrs.CODECS,
        resolution: level.attrs.RESOLUTION,
        height: level.height,
        width: level.width
    };
}

export function resolveMaxLevel(maxLevelFromConfig:number, maxLevelFromUser:number, maxLevelFromPlayerSize = -1) {
    if (!isNumber(maxLevelFromConfig))maxLevelFromConfig = -1;
    if (!isNumber(maxLevelFromUser))maxLevelFromUser = -1;
    if (!isNumber(maxLevelFromPlayerSize))maxLevelFromPlayerSize = -1;

    // Long story short:
    // if level is capped in config, there is no way it can be higher than that
    // then if user selected a resolution, we bypass player size level capping

    // level is not capped in config
    if (maxLevelFromConfig === -1) {
        // user did not select a resolution
        if (maxLevelFromUser === -1) {
            // so level is capped by player size
            return maxLevelFromPlayerSize;
        }
        // user selected a resolution, we bypass player size
        return maxLevelFromUser;
    }

    // level is capped in config

    // user did select a resolution, we bypass player size
    if (maxLevelFromUser !== -1) {
        return Math.min(maxLevelFromConfig, maxLevelFromUser);
    }

    // user did not select a resolution

    // level is not capped by player size
    if (maxLevelFromPlayerSize === -1) {
        return maxLevelFromConfig;
    }

    // level is capped by player size and config, not by user

    return Math.min(maxLevelFromConfig, maxLevelFromPlayerSize);
}

export function getCapLevelController(maxLevelFromConfigGetter: () => number, maxLevelFromUserGetter: () => number): typeof CapLevelController {
    const DefaultController = Hls.DefaultConfig.capLevelController;

    class SpotmeCapLevelController extends DefaultController {
        getMaxLevel(capLevelIndex: number): number {
            const maxLevelFromPlayerSize = super.getMaxLevel(capLevelIndex);
            return resolveMaxLevel(maxLevelFromConfigGetter(), maxLevelFromUserGetter(), maxLevelFromPlayerSize);
        }
    }

    return SpotmeCapLevelController;
}
